<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      class="text"
      :itemvalue="itemvalue"
      :disabled="disabled"
      :value="value"
      id="TrnID" itemtext="TrnDescription"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      :noDefault="clearable"
    >
    </s-select-generic>
  </div>
</template>
<script>

import _sService from "@/services/FreshProduction/ComponentTurn.js";

export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "Turnos",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
    TypeArea: null,
    typeShip: {type: Number, default: 1},
    itemvalue:{ type: String, default: "TrnID"}
  },
  watch: {
    value(value) {
      this.item = value;
    },
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    this.config = {
      url: _sService.listTurnInProcess(),
      title: this.label,
      params: { TypeShip: this.typeShip, TypeArea: this.TypeArea,  requestID: this.$fun.getUserID() },
    };
  },
};
</script>
